<template>
    <v-form
        data-vv-scope="addressForm"
        v-model="valid"
    >
        <!--              <pre>{{ $v.newPersonCountryId }}</pre>-->
        <v-container
            grid-list-md
            pt-0
        >
            <v-layout wrap>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        :error-messages="newPersonAddressLineOneErrors"
                        @blur="$v.newPersonAddressLineOne.$touch()"
                        @input="$v.newPersonAddressLineOne.$touch()"

                        label="Address Line One"
                        type="text"
                        v-model="newPersonAddressLineOne"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        :error-messages="newPersonAddressLineTwoErrors"
                        @blur="$v.newPersonAddressLineTwo.$touch()"
                        @input="$v.newPersonAddressLineTwo.$touch()"

                        label="Address Line Two"
                        type="text"
                        v-model="newPersonAddressLineTwo"
                    />
                </v-flex>
                <v-flex
                    md4
                    sm6
                    xs12
                >
                    <v-text-field
                        label="Town"
                        type="text"
                        v-model="newPersonTown"
                    />
                </v-flex>
                <v-flex
                    md4
                    sm6
                    xs12
                >
                    <v-text-field
                        label="County"
                        type="text"
                        v-model="newPersonCounty"
                    />
                </v-flex>
                <v-flex
                    md4
                    sm6
                    xs12
                >
                    <v-text-field
                        :error-messages="newPersonPostCodeErrors"
                        @blur="$v.newPersonPostCode.$touch()"
                        @input="$v.newPersonPostCode.$touch()"

                        label="Postcode"
                        type="text"
                        v-model="newPersonPostCode"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-autocomplete
                        :error-messages="newPersonCountryIdErrors"
                        :items="personnelCountryList"
                        @blur="$v.newPersonCountryId.$touch()"
                        @input="$v.newPersonCountryId.$touch()"
                        item-text="name"

                        item-value="personnelCountryId"
                        label="Country"
                        v-model="newPersonCountryId"
                    />
                </v-flex>
                <v-flex
                    md6
                    sm12
                    xs12
                >
                    <v-text-field
                        label="Longitude"
                        type="text"
                        v-model="newPersonAddressLongitude"
                    />
                </v-flex>
                <v-flex
                    md6
                    sm12
                    xs12
                >
                    <v-text-field
                        label="Latitude"
                        type="text"
                        v-model="newPersonAddressLatitude"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        counter
                        label="Comments"
                        maxlength="90"
                        type="text"
                        v-model="newPersonAddressComments"
                    />
                </v-flex>
            </v-layout>
        </v-container>
        <!--    <v-btn @click="validate">Submit</v-btn>-->
        <!--      <v-btn @click="changeStep(-1)">Previous</v-btn>-->
        <!--      <v-btn @click="changeStep(+1)">Next</v-btn>-->
        <!--                <v-btn @click="redirect">redirect</v-btn>-->
    </v-form>
</template>

<script>
    import {mapGetters} from "vuex";
    import {required,} from 'vuelidate/lib/validators'
    import {SET_NEW_PERSON_FORM_SECTION_STATE, UPDATE_NEW_PERSON} from "@/store/person/mutations";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "../../../store/personnel_country/actions";

    export default {
        name: "Address",

        validations: {
            newPersonAddressLineOne: {required},
            newPersonAddressLineTwo: {},
            newPersonPostCode: {required},
            newPersonCountryId: {required}
        },

        data: function () {
            return {
                valid: false,
            }
        },

        computed: {
            newPersonAddressLineOne: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].addressLineOne;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'addressLineOne';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonAddressLineOneErrors() {
                const errors = [];
                if (!this.$v.newPersonAddressLineOne.$dirty) return errors;
                !this.$v.newPersonAddressLineOne.required && errors.push('Required.');
                return errors
            },

            newPersonAddressLineTwo: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].addressLineTwo;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'addressLineTwo';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonAddressLineTwoErrors() {
                return [];
            },

            newPersonTown: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].town;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'town';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonCounty: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].county;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'county';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonPostCode: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].postCode;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'postCode';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonPostCodeErrors() {
                const errors = [];
                if (!this.$v.newPersonPostCode.$dirty) return errors;
                !this.$v.newPersonPostCode.required && errors.push('Required.');
                return errors
            },

            newPersonCountryId: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].personnelCountryId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'personnelCountryId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonCountryIdErrors() {
                const errors = [];
                if (!this.$v.newPersonCountryId.$dirty) return errors;
                !this.$v.newPersonCountryId.required && errors.push('Required.');
                return errors
            },

            newPersonAddressLongitude: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].longitude;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'longitude';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonAddressLatitude: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].latitude;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'latitude';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonAddressComments: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].comments;
                },
                set(value) {
//                    console.log(value);
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'comments';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            ...mapGetters(
            [
                "personnelCountryList"
            ]
            ),
        },

        mounted() {
            this.fetchPersonnelCountryList();
        },


        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            validate() {
                this.$v.$touch();

                let formState = false;


                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'address', state: formState});
            },
        },

    }
</script>

<style scoped>

</style>
